import { isNil } from 'lodash'

import {
  DataField,
  onFieldInputValueChange,
  onFieldReact
} from '@eastcoal/formily/exports/core'

import { KIND_FIELD } from '../../constants/field'

/**
 * “标的物”联动逻辑
 */
export const productNameEffect = () => {
  onFieldInputValueChange(KIND_FIELD, (field, form) => {
    const value = field.value

    form.setFieldState('productName', state => {
      state.value = value?.name
    })
  })
  onFieldReact(KIND_FIELD, (field, form) => {
    const kindField = field as DataField
    form.setFieldState('productName', state => {
      state.disabled = !form.editable || isNil(kindField.value?.id)
    })
  })
}
